<div mat-dialog-content>

  <div class="row">

      <div class="col-md-12">
          <div class="closebtn" (click)="close()">
              <i class="bi bi-x-circle"></i>
          </div>
          <div class="conselling-form">
            <form [formGroup]="counsellingForm">
              <h5>Fill in the form for a Quick Call back.</h5>

                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill" class="mat_form_filed">
                            <mat-label>Enter Your Name</mat-label>
                            <input matInput formControlName="name">
                        </mat-form-field>
                    </div>

                    <div class="col-md-12">
                        <mat-form-field appearance="fill" class="mat_form_filed">
                            <mat-label>Enter Your Phone Number</mat-label>
                            <input matInput formControlName="mobile">
                        </mat-form-field>
                    </div>

                    <div class="col-md-12">
                        <mat-form-field appearance="fill" class="mat_form_filed">
                            <mat-label>Enter Your Email ID</mat-label>
                            <input matInput formControlName="email">
                        </mat-form-field>
                    </div>

                  

                    <div class="col-md-6 col-6">
                        <mat-form-field appearance="fill" class="mat_form_filed">
                            <mat-label>Target Year</mat-label>
                            <mat-select formControlName="year">
                                <mat-option value="2025">2025</mat-option>
                                <mat-option value="2026">2026</mat-option>
                                <mat-option value="2027">2027</mat-option>
                                <mat-option value="2028">2028</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                  
                    <div class="col-md-6 col-6 pl-1">
                        <button mat-button (click)="submit()">Submit</button>
                    </div>

                    <!-- <div class="col-md-12">
                        <h6>
                            I authorize Indrajeet's iQuanta Edu Services and its representatives to call, SMS,
                            Email or WhatsApp me about its products and offers.This consent overrides any
                            registration for DND and NDNC.
                        </h6>
                    </div> -->
                </div>
            </form>
        </div>
      </div>

  </div>

</div>